// extracted by mini-css-extract-plugin
module.exports = {"content":"ReadStory_content__g2Ch7","gradient":"ReadStory_gradient___cuL7","readStoryButton":"ReadStory_readStoryButton__IWqB_"};